import liveSessionService from '../../services/livesession/LiveSessionService';
import utilService from '../../services/UtilService';
import settingsReader from '../../store/readHelpers/SettingsReader';

class RecordingCallMediaConstraintsStatic {
    constructor() {
        this.videoWidth = null;
        this.videoHeight = null;
        this.videoFrameRate = null;
        this.audioChannelCount = null;
        this.audioSampleRate = null;
        this.audioGoogleEnhancements = null;
    }

    copy() {
        const constraintsCopy = new RecordingCallMediaConstraintsStatic();

        constraintsCopy.videoWidth = this.videoWidth;
        constraintsCopy.videoHeight = this.videoHeight;
        constraintsCopy.videoFrameRate = this.videoFrameRate;
        constraintsCopy.audioChannelCount = this.audioChannelCount;
        constraintsCopy.audioSampleRate = this.audioSampleRate;
        constraintsCopy.audioGoogleEnhancements = this.audioGoogleEnhancements;

        return constraintsCopy;
    }

    checkRange() {
        utilService.checkInRange('videoWidth', this.videoWidth, 360, 1920);
        utilService.checkInRange('videoHeight', this.videoHeight, 180, 1440);
        utilService.checkInRange('videoFrameRate', this.videoFrameRate, 1, 60);
        utilService.checkInRange('audioChannelCount', this.audioChannelCount, 1, 2);
        utilService.checkInRange('audioSampleRate', this.audioSampleRate, 8000, 48000);

        if (typeof this.audioGoogleEnhancements !== 'boolean') {
            throw new Error(
                'audioGoogleEnhancements is not a boolean'
            );
        }
    }

    video() {
        this.checkRange();
        return {
            width: this.videoWidth,
            height: this.videoHeight,
            frameRate: this.videoFrameRate,
            facingMode: 'user',
        };
    }

    audio() {
        this.checkRange();
        const audioEnhancements = liveSessionService.getAudioEnhancements();
        const constraints = {
            channelCount: this.audioChannelCount,
            sampleRate: this.audioSampleRate,
            ...audioEnhancements,
        };

        return constraints;
    }

    setRecordingConstraints() {
        const videoEnhancementsResolution = settingsReader.getWebRTCRecordingResolution();
        const videoEnhancementsFps = settingsReader.getWebRTCRecordingFPS();

        this.videoWidth = videoEnhancementsResolution?.videoWidth;
        this.videoHeight = videoEnhancementsResolution?.videoHeight;
        this.videoFrameRate = videoEnhancementsFps;
    }
}

export default RecordingCallMediaConstraintsStatic;
